export default __webpack_public_path__ + "static/4-2--b6327b0861dc0babfed2ac9b80f616c3.png";